document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('typewriter');
  if (!el) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    el.textContent = 'TREASURE';
    return;
  }
  const words = [
    'TREASURE',
    'SPORTS CARDS',
    'TREASURE',
    'POKEMON',
    'TREASURE',
    'MAGIC: THE GATHERING',
    'TREASURE',
    'COMICS',
    'TREASURE',
    'JEWELRY',
    'TREASURE',
    'VINTAGE CLOTHING',
    'TREASURE',
    'MODERN CLOTHING',
  ];
  const TYPE_MS = 70, DELETE_MS = 35, HOLD_MS = 1400, GAP_MS = 250;
  let wordIdx = 0, charIdx = words[0].length, mode = 'holding';
  let lastT = performance.now(), nextDelay = HOLD_MS;
  el.textContent = words[0];

  function tick(now) {
    if (now - lastT >= nextDelay) {
      lastT = now;
      const word = words[wordIdx];
      if (mode === 'typing') {
        charIdx++;
        el.textContent = word.slice(0, charIdx);
        if (charIdx >= word.length) { mode = 'holding'; nextDelay = HOLD_MS; }
        else nextDelay = TYPE_MS + (Math.random() * 30 - 15);
      } else if (mode === 'holding') { mode = 'deleting'; nextDelay = DELETE_MS; }
      else if (mode === 'deleting') {
        charIdx--;
        el.textContent = word.slice(0, charIdx);
        if (charIdx <= 0) { mode = 'gap'; nextDelay = GAP_MS; } else nextDelay = DELETE_MS;
      } else if (mode === 'gap') {
        wordIdx = (wordIdx + 1) % words.length;
        mode = 'typing'; nextDelay = TYPE_MS;
      }
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
});
